import mergeConfig from 'coact/config/mergeConfig'
import staffersSchema from './staffers/schema.js'

const config = {
  models: {
    staffers: {
      schema: staffersSchema,
    },
  },
}

export default fullConfig => mergeConfig(fullConfig, config)
